import React from "react";
import { useTranslation } from "react-i18next";
import { TypeSpecificFieldsProps } from "./types";

const CriticalIllnessFields: React.FC<TypeSpecificFieldsProps> = ({ data, onChange }) => {
  const { t } = useTranslation(['insurance', 'common']);
  const set = (key: string, value: any) => onChange({ ...data, [key]: value });

  return (
    <div className="irf-grid">
      <div className="irf-field">
        <label>{t('insurance:criticalIllness.numberOfIllnessesCovered')}</label>
        <input
          type="number"
          value={data.number_of_illnesses_covered ?? ""}
          onChange={(e) => set("number_of_illnesses_covered", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:criticalIllness.numberOfIllnessesCoveredPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:criticalIllness.illnessesList')}</label>
        <input
          value={data.illnesses_list || ""}
          onChange={(e) => set("illnesses_list", e.target.value)}
          placeholder={t('insurance:criticalIllness.illnessesListPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:criticalIllness.survivalPeriodDays')}</label>
        <input
          type="number"
          value={data.survival_period_days ?? ""}
          onChange={(e) => set("survival_period_days", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:criticalIllness.survivalPeriodDaysPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:criticalIllness.waitingPeriodDays')}</label>
        <input
          type="number"
          value={data.waiting_period_days ?? ""}
          onChange={(e) => set("waiting_period_days", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:criticalIllness.waitingPeriodDaysPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:criticalIllness.maximumClaims')}</label>
        <input
          type="number"
          value={data.max_claims ?? ""}
          onChange={(e) => set("max_claims", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:criticalIllness.maximumClaimsPlaceholder')}
        />
      </div>
    </div>
  );
};

export default CriticalIllnessFields;
